export enum ErrorType {
  VALIDATION_ERROR = 'validation_error',
  API_ERROR = 'api_error',
  NETWORK_ERROR = 'network_error',
  TIMEOUT = 'timeout',
  PERMISSION_DENIED = 'permission_denied',
  UNKNOWN = 'unknown',
}

export enum OnboardingErrorStep {
  WELCOME = 'welcome',
  MFA = 'mfa',
  ORG_DETAILS = 'org_details',
  CLINICIAN_TYPE = 'clinician_type',
  SESSION_STARTED = 'session_started',
  SIGN_UP_FORM = 'sign_up_form',
  PASSWORD_CREATE = 'password_create',
  CUSTOMIZE_ORGANIZATION = 'customize_organization',
  // Onboarding-v2 / learn-basics flow steps
  ABOUT_YOU = 'about_you',
  MIC_TEST = 'mic_test',
  PROFILE_UPDATE = 'profile_update',
  REGION_UPDATE = 'region_update',
  TEMPLATE_SAVE = 'template_save',
}
